import chest01 from './chest-01.png';
import chest02 from './chest-02.png';
import chest03 from './chest-03.png';
import chest04 from './chest-04.png';
import chest06 from './chest-06.png';
import chest07 from './chest-07.png';
import defaultSkin from './default.png';
import foxbet from './foxbet.png';
import pspc from './pspc.png';
import stadium from './stadium.png';
import vault from './vault.png';

export const starsRewardsChestSkinMap = {
  SRTier1: chest01,
  SRTier2: chest01,
  SRCVL2Tier1: chest01,
  SRTier3: chest02,
  SRCVL2Tier2: chest02,
  SRTier4: chest03,
  SRCVL2Tier3: chest03,
  SRTier5: chest04,
  SRCVL2Tier4: chest04,
  SRTier6: chest06,
  SRCVL2Tier5: chest06,
  SRCVL2Tier6: chest07
};

export const legacyChestSkinMap = {
  christmas: defaultSkin,
  default: defaultSkin,
  foxbet,
  mpc: defaultSkin,
  pirate: defaultSkin,
  pspc,
  skybet: defaultSkin,
  stadium,
  vault
};
